const quickLinks = [
  { id: 'latest', label: '最新黑料合集' },
  { id: 'exclusive', label: '独家爆料' },
  { id: 'stars', label: '明星专区' },
  { id: 'influencers', label: '网红专区' },
  { id: 'timeline', label: '吃瓜时间线' },
  { id: 'ranking', label: '吃瓜热度榜' },
  { id: 'guide', label: '理性吃瓜指南' },
];

const topics = ['明星黑料', '网红黑料', '综艺风波', '直播带货', '情感纠葛', '塌房现场'];

export default function Footer() {
  return (
    <footer className="w-full bg-secondary-100 border-t border-secondary-200">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2 mb-4 cursor-pointer" aria-label="黑料吃瓜网 回到顶部">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-2xl text-secondary-900">黑料吃瓜网</span>
            </a>
            <p className="text-sm text-secondary-800 leading-relaxed font-body max-w-md">
              汇集最新黑料与今日爆料，覆盖明星、网红等独家黑料合集，帮吃瓜群众快速厘清事件来龙去脉，获取一手八卦资讯。
            </p>
            <p className="mt-4 text-xs text-secondary-700 leading-relaxed font-body max-w-md">
              本站内容为网络公开讨论整理，人物均为化名，仅供娱乐参考，不构成事实认定。如有侵权请联系处理。
            </p>
          </div>

          <nav aria-label="页脚分区导航">
            <h2 className="font-heading text-lg text-secondary-900 mb-4">内容分区</h2>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.id}>
                  <a
                    href={`#${link.id}`}
                    className="text-sm text-secondary-800 hover:text-primary-600 transition-colors cursor-pointer font-body"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-lg text-secondary-900 mb-4">热门话题</h2>
            <div className="flex flex-wrap gap-2">
              {topics.map((topic) => (
                <span
                  key={topic}
                  className="px-2.5 py-1 rounded-md bg-secondary-200 text-secondary-900 text-xs font-label"
                >
                  {topic}
                </span>
              ))}
            </div>
            <div className="mt-5 flex items-center gap-3">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-200 text-secondary-800">
                <i className="ri-wechat-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-200 text-secondary-800">
                <i className="ri-weibo-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-200 text-secondary-800">
                <i className="ri-at-line text-lg" aria-hidden="true"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-700 font-label">© 2026 黑料吃瓜网 · 吃瓜需理性，事实更值得等待</p>
          <a
            href="#top"
            className="inline-flex items-center gap-1.5 text-xs text-secondary-800 hover:text-primary-600 transition-colors cursor-pointer font-label"
          >
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}